export default __webpack_public_path__ + "static/media/eyeProtofoilo.faf24c1e.jpg";